module.exports = __webpack_public_path__ + "img/sel_Shanghai-.a4e8e43d.png";